import { Grid } from "@material-ui/core";
import { Sync } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { HttpClient } from "../../../web-services/http-client";
import { IParkingZoneData } from "../../../web-services/models/parking-zone-data";
import { DisplayCard } from "../../common/display-card";
import { ProgressDialog } from "../../common/progress-dialog";
import "./landing-page.scss";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function LandingPage(props: { httpClient: HttpClient })
{
    const [parkingZoneData, setParkingZoneData] = useState<IParkingZoneData[]>([]);
    const [isSendingRequest, setIsSendingRequest] = useState<boolean>(true);
    const [progressDialogOpened, setProgressDialogOpened] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>();
    const [errorCategoryMsg, setErrorCategoryMsg] = useState<string>();

    useEffect(() =>
    {
        if (!isSendingRequest) return;
        setProgressDialogOpened(true);
        const fetchData = async () =>
        {
            setErrorMsg(undefined);
            setErrorCategoryMsg(undefined);
            try
            {
                let data = (await props.httpClient.get<IParkingZoneData[]>("values/get-parking-lot-data", "", 15000)).data;
                setParkingZoneData(data || []);
                setProgressDialogOpened(false);
            }
            catch (err: any)
            {
                console.log(err);

                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorCategoryMsg("Kapcsolati hiba");
                    setErrorMsg("Kérjük, próbálja újra a parkolózónák letöltését.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }
            setIsSendingRequest(false);

        };

        fetchData().catch(console.error);

    }, [isSendingRequest]);

    return (
        <div className = "scrollable-container centered">
            <div className="display-cards-container">
                <Grid container spacing={2}>
                    <ProgressDialog
                        text="Parkolózónák betöltése folyamatban"
                        retryButtonText="Újra lekérem"
                        onRetryButtonClick={() => setIsSendingRequest(true)}
                        onCancelButtonClick={() => setProgressDialogOpened(false)}
                        retryButtonIcon={<Sync />}
                        errorText={errorMsg}
                        errorCategoryText={errorCategoryMsg}
                        open={progressDialogOpened}
                    />
                    {parkingZoneData.map((elem, i) => (
                        <Grid item xs={12} md={4} key={i}>
                            <DisplayCard
                                title={elem.parkingLotName}
                                allParkingSpace={elem.allPlaces}
                                freeParkingSpace={elem.freePlaces}
                                warningMessage={elem.errorMsg}
                                parkingLotId={elem.parkingLotId}
                                isPlaceholderData={elem.isPlaceholderData}
                            />
                        </Grid>
                    ))}
                </Grid>
            </div>
        </div>
    );
}
